export default "__VITE_ASSET__BGPkLOjC__"